import React, {useEffect, useState} from 'react';
import {Grid} from '@mui/material';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import './Footer.scss';
import FacebookIcon from '@mui/icons-material/Facebook';
import YouTubeIcon from '@mui/icons-material/YouTube';
import InstagramIcon from '@mui/icons-material/Instagram';
import {researchList} from '../../../services/InvitationServices';

export default function Footer() {
  const [researchMaterial, setResearchMaterial] = useState([]);

  useEffect(() => {
    fetchMaterials();
  },[]);

  const fetchMaterials = () => {
    researchList('get').then(res => {
      setResearchMaterial(res?.data);
    })
  }

  return (
    <Box className={'footerContainer'}>
      <Grid container sx={{pt: {sm: 8, xs: 4}, pl: {sm: 8, xs: 4}, pr: {sm: 8, xs: 4}, pb: {sm: 2, xs: 1}}} spacing={2}>
        <Grid item sm={4}>
          <Typography className={'footerTitle'}>Research links</Typography>
          <Grid container>
            {researchMaterial?.length > 0 && researchMaterial?.map((material, index) => (
            <Grid item sm={12} xs={12} key={index} style={{marginBottom: '1%'}}>
              <a href={material?.site_url} target={'_blank'}>
                <Typography sx={{color: '#fff'}}>{material?.title}</Typography>
              </a>
            </Grid>
            ))}
          </Grid>
        </Grid>
        <Grid item sm={4}>
          <Typography className={'footerTitle'}>Visiting hour</Typography>
          <Typography className={'footerDescription'}>
            9:00 AM - 4:00 PM
          </Typography>
        </Grid>
        <Grid item sm={4} sx={{mb: {xs: 5, lg: 0, md: 0, sm: 0}}}>
          <Typography className={'footerTitle'}>About the museum</Typography>
          <Typography className={'footerDescription'}>
            Help
          </Typography>
          <Typography className={'footerDescription'}>
            Report
          </Typography>
        </Grid>
      </Grid>
      <Grid container sx={{pl: {sm: 6, xs: 4}, pr: {sm: 6, xs: 4}, pb: {sm: 6, xs: 4}}}>
        <Grid item sm={8}>
          <Box display={'flex'} alignItems={'center'}>
            <img draggable={false} width={77} src={require('../../../assets/Images/DCDDLogo.png')} alt="logo"/>
            <Box>
              <Typography sx={{fontSize: 30, fontWeight: 700, color: '#fff'}}>
                Museums of Bhutan
              </Typography>
              <Typography className={'footerDescription'}>
                © 2024 Museums of Bhutan. All rights reserved.
              </Typography>
            </Box>
          </Box>
        </Grid>
        <Grid item sm={3}>
          <Box display={'flex'} alignItems={'center'} sx={{mt: {xs: 5, lg: 0, md: 0, sm: 0}}}>
            <a href={'https://www.facebook.com/museumdivision?mibextid=ZbWKwL'} target={'_blank'}>
              <FacebookIcon sx={{color: '#fff', fontSize: 40}}/>
            </a>
            <a href={'https://www.youtube.com/@MuseumsofBhutan'} target={'_blank'}>
              <YouTubeIcon sx={{color: '#fff', fontSize: 50, marginLeft: 3, marginRight: 3}}/>
            </a>
            <a href={'https://www.instagram.com/museumsofbhutan?utm_source=qr&igsh=cnpkbnF4bnZ6YzRi'} target={'_blank'}>
              <InstagramIcon sx={{color: '#fff', fontSize: 40}}/>
            </a>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}
